import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Navbar, Nav } from "react-bootstrap";
import "../styles/Navbar.css";
import { Link, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
const CustomNavbar = () => {
  const [activeLink, setActiveLink] = useState(null);
  const [expanded, setExpanded] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 991);
  const location = useLocation();
  useEffect(() => {
    const path = location.pathname;
    const pathMap = {
      "/": "/",
      "/aboutus/": "about",
      "/contact": "contact",
      "/blogs": "blogs",
      "/portfolio": "portfolio",
      "/uiuxdesign": "uiuxdesign",
      "/web-development": "web-development",
      "/mobile-application-development": "mobile-application-development",
      "/digital-marketing": "digital-marketing",
      "/customsoftwaresolution": "customsoftwaresolution",
      "/seoservices": "seoservices",
      "/social-media-marketing": "social-media-marketing",
      "/e-commerce": "e-commerce",
      "/wordpress": "wordpress",
      "/php-dev": "php-dev",
      "/laravel-dev": "laravel-dev",
      "/react-dev": "react-dev",
      "/node-dev": "node-dev",
      "/flutter-dev": "flutter-dev",
      "/python-dev": "python-dev",
      "/qa-engineers": "qa-engineers",
      "/crm": "crm",
      "/pos": "pos",
      "/real-estate": "real-estate",
      "/rental-booking": "rental-booking",
      "/single-vendor": "single-vendor",
      "/multi-vendor": "multi-vendor",
      "/travelagencyandtourbooking": "travelagencyandtourbooking",
      "/lms": "lms",
      "/realestatedirectory": "realestatedirectory",
      "/eventtime": "eventtime",
      "/onest": "onest",
      "/aifsd": "aifsd",
      "/mpproperty": "mpproperty",
      "/mpjobs": "mpjobs",
      "/mprelax": "mprelax",
      "/mpskills": "mpskills",
      "/mpdoctor": "mpdoctor",
      "/mpmatrimony": "mpmatrimony",
      "/mpdemand": "mpdemand",
      "/mpfood": "mpfood",
      "/mpbid": "mpbid",
      "/mp-lms": "mp-lms"
    };

    setActiveLink(pathMap[path] || null);
  }, [location]);
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 991);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const toggleDropdown = (dropdownName) => {
    if (isMobile) {
      setActiveDropdown(activeDropdown === dropdownName ? null : dropdownName);
    }
  };
  const closeNavbar = () => {
    setExpanded(false);
    setActiveDropdown(null);
  };
  const isWhoWeAreActive = [
    "uiuxdesign",
    "web-development",
    "mobile-application-development",
    "digital-marketing",
    "customsoftwaresolution",
    "seoservices",
    "social-media-marketing",
    "e-commerce",
    "wordpress"
  ].includes(activeLink);

  const isHireDevsActive = [
    "php-dev",
    "laravel-dev",
    "react-dev",
    "node-dev",
    "flutter-dev",
    "python-dev",
    "qa-engineers"
  ].includes(activeLink);

  const isCustomActive = [
    "crm",
    "pos",
    "real-estate",
    "rental-booking",
    "single-vendor",
    "multi-vendor",
    "travelagencyandtourbooking",
    "lms",
    "realestatedirectory",
    "eventtime",
    "onest",
    "aifsd",
    "mpproperty",
    "mpjobs",
    "mprelax",
    "mpskills",
    "mpdoctor",
    "mpmatrimony",
    "mpdemand",
    "mpfood",
    "mp-lms"
  ].includes(activeLink);
  return (
    <>
      <Navbar expand="lg" className="custom-navbar" expanded={expanded}>
        <div className="navbar-container">
          <div className="logocontain">
            <div className="logocontain1">
              <Navbar.Brand href="/" className="logo">
                <img
                  src="/images/logomp.png"
                  alt="Logo"
                  className="logoimgs"
                  height="65px"
                  width="195px"
                />
              </Navbar.Brand>
            </div>
            <div>
              <Navbar.Toggle
                className="menu-icon"
                onClick={() => setExpanded(!expanded)}
              >
                {expanded ? "✖" : "☰"}
              </Navbar.Toggle>
            </div>
          </div>
          <div>
            <Navbar.Collapse id="navbar-nav ">
              <Nav className="nav-links">
                {expanded && (
                  <div className="mobile-header">
                    <img
                      src="/images/logomp.png"
                      alt="Logo"
                      height="100%"
                      width="105px"
                      style={{
                        width: "105px",
                        height: "auto",
                        marginBottom: "20px"
                      }}
                    />
                    <Navbar.Toggle
                      className="menu-icon close-btn"
                      onClick={() => setExpanded(!expanded)}
                    >
                      ✖
                    </Navbar.Toggle>
                  </div>
                )}
                <Link
                  to="/"
                  onClick={() => {
                    setExpanded(false);
                    setActiveLink("/");
                  }}
                  className={`nav-link ${activeLink === "/" ? "active" : ""}`}
                >
                  Home
                </Link>
                <Link
                  to="/aboutus/"
                  onClick={() => {
                    setExpanded(false);
                    setActiveLink("about");
                  }}
                  className={activeLink === "about" ? "active" : ""}
                >
                  About Us
                </Link>
                 <Link
                  to="/portfolio"
                  onClick={() => {
                    setExpanded(false);
                    setActiveLink("portfolio");
                  }}
                  className={activeLink === "portfolio" ? "active" : ""}
                >
                  Portfolio
                </Link> 
                <div
                  className="dropdown-container who-we-are-dropdown"
                  onMouseEnter={() =>
                    !isMobile && setActiveDropdown("whoWeAre")
                  }
                  onMouseLeave={() => !isMobile && setActiveDropdown(null)}
                >
                  <button
                    className={`dropdown-toggle ${
                      isWhoWeAreActive ? "active" : ""
                    }`}
                    onClick={() => toggleDropdown("whoWeAre")}
                    aria-expanded={activeDropdown === "whoWeAre"}
                  >
                    Who We Are
                    <span
                      className={`dropdown-arrow ${
                        activeDropdown === "whoWeAre" ? "rotate" : ""
                      }`}
                    >
                      <FontAwesomeIcon icon={faChevronDown} />
                    </span>
                  </button>
                  <div
                    className={`dropdown-content ${
                      activeDropdown === "whoWeAre" ? "show" : ""
                    }`}
                  >
                    <div className="dropdown-column">
                      <Link
                        to="/uiuxdesign"
                        onClick={() => {
                          closeNavbar();
                          setActiveLink("uiuxdesign");
                        }}
                        className={activeLink === "uiuxdesign" ? "active" : ""}
                      >
                        UI/UX Design
                      </Link>
                      <Link
                        to="/web-development"
                        onClick={() => {
                          closeNavbar();
                          setActiveLink("web-development");
                        }}
                        className={
                          activeLink === "web-development" ? "active" : ""
                        }
                      >
                        Web Development
                      </Link>
                      <Link
                        to="/mobile-application-development"
                        onClick={() => {
                          closeNavbar();
                          setActiveLink("mobile-application-development");
                        }}
                        className={
                          activeLink === "mobile-application-development"
                            ? "active"
                            : ""
                        }
                      >
                        Mobile App Development
                      </Link>
                      <Link
                        to="/digital-marketing"
                        onClick={() => {
                          closeNavbar();
                          setActiveLink("digital-marketing");
                        }}
                        className={
                          activeLink === "digital-marketing" ? "active" : ""
                        }
                      >
                        Digital Marketing
                      </Link>
                      <Link
                        to="/customsoftwaresolution"
                        onClick={() => {
                          closeNavbar();
                          setActiveLink("customsoftwaresolution");
                        }}
                        className={
                          activeLink === "customsoftwaresolution"
                            ? "active"
                            : ""
                        }
                      >
                        Custom Software Solution
                      </Link>
                    </div>
                    <div className="dropdown-column">
                      <Link
                        to="/seoservices"
                        onClick={() => {
                          closeNavbar();
                          setActiveLink("seoservices");
                        }}
                        className={activeLink === "seoservices" ? "active" : ""}
                      >
                        SEO Services
                      </Link>
                      <Link
                        to="/social-media-marketing"
                        onClick={() => {
                          closeNavbar();
                          setActiveLink("social-media-marketing");
                        }}
                        className={
                          activeLink === "social-media-marketing"
                            ? "active"
                            : ""
                        }
                      >
                        Social Media Marketing
                      </Link>
                      <Link
                        to="/e-commerce"
                        onClick={() => {
                          closeNavbar();
                          setActiveLink("e-commerce");
                        }}
                        className={activeLink === "e-commerce" ? "active" : ""}
                      >
                        E-commerce Development
                      </Link>
                      <Link
                        to="/wordpress"
                        onClick={() => {
                          closeNavbar();
                          setActiveLink("wordpress");
                        }}
                        className={activeLink === "wordpress" ? "active" : ""}
                      >
                        WordPress Development
                      </Link>
                    </div>
                  </div>
                </div>
                <div
                  className="dropdown-container hire-developers-dropdown"
                  onMouseEnter={() =>
                    !isMobile && setActiveDropdown("hireDevelopers")
                  }
                  onMouseLeave={() => !isMobile && setActiveDropdown(null)}
                >
                  <button
                    className={`dropdown-toggle ${
                      isHireDevsActive ? "active" : ""
                    }`}
                    onClick={() => toggleDropdown("hireDevelopers")}
                    aria-expanded={activeDropdown === "hireDevelopers"}
                  >
                    Careers
                    <span
                      className={`dropdown-arrow ${
                        activeDropdown === "hireDevelopers" ? "rotate" : ""
                      }`}
                    >
                      <FontAwesomeIcon icon={faChevronDown} />
                    </span>
                  </button>
                  <div
                    className={`dropdown-content ${
                      activeDropdown === "hireDevelopers" ? "show" : "hide"
                    }`}
                  >
                    <div className="dropdown-column">
                      <Link
                        to="/php-dev"
                        onClick={() => {
                          closeNavbar();
                          setActiveLink("php-dev");
                        }}
                        className={activeLink === "php-dev" ? "active" : ""}
                      >
                        PHP Developer
                      </Link>
                      <Link
                        to="/laravel-dev"
                        onClick={() => {
                          closeNavbar();
                          setActiveLink("laravel-dev");
                        }}
                        className={activeLink === "laravel-dev" ? "active" : ""}
                      >
                        Laravel Developer
                      </Link>
                      <Link
                        to="/react-dev"
                        onClick={() => {
                          closeNavbar();
                          setActiveLink("react-dev");
                        }}
                        className={activeLink === "react-dev" ? "active" : ""}
                      >
                        React Developer
                      </Link>
                      <Link
                        to="/node-dev"
                        onClick={() => {
                          closeNavbar();
                          setActiveLink("node-dev");
                        }}
                        className={activeLink === "node-dev" ? "active" : ""}
                      >
                        Node Developer
                      </Link>
                    </div>
                    <div className="dropdown-column">
                      <Link
                        to="/flutter-dev"
                        onClick={() => {
                          closeNavbar();
                          setActiveLink("flutter-dev");
                        }}
                        className={activeLink === "flutter-dev" ? "active" : ""}
                      >
                        Flutter Developer
                      </Link>
                      <Link
                        to="/python-dev"
                        onClick={() => {
                          closeNavbar();
                          setActiveLink("python-dev");
                        }}
                        className={activeLink === "python-dev" ? "active" : ""}
                      >
                        Python Developer
                      </Link>
                      <Link
                        to="/qa-engineers"
                        onClick={() => {
                          closeNavbar();
                          setActiveLink("qa-engineers");
                        }}
                        className={
                          activeLink === "qa-engineers" ? "active" : ""
                        }
                      >
                        QA Engineers
                      </Link>
                    </div>
                  </div>
                </div>
                {/* <div
                  className="dropdown-container hire-developers-dropdown"
                  onMouseEnter={() =>
                    !isMobile && setActiveDropdown("Custom Menu")
                  }
                  onMouseLeave={() => !isMobile && setActiveDropdown(null)}
                >
                  <button
                    className={`dropdown-toggle ${
                      isCustomActive ? "active" : ""
                    }`}
                    onClick={() => toggleDropdown("Custom Menu")}
                    aria-expanded={activeDropdown === "Custom Menu"}
                  >
                    Industry Solutions
                    <span
                      className={`dropdown-arrow ${
                        activeDropdown === "Custom Menu" ? "rotate" : ""
                      }`}
                    >
                      <FontAwesomeIcon icon={faChevronDown} />
                    </span>
                  </button>
                  <div
                    className={`dropdown-content ${
                      activeDropdown === "Custom Menu" ? "show" : "hide"
                    }`}
                  >
                    <div className="dropdown-column">
                      <Link
                        to="/crm"
                        onClick={() => {
                          closeNavbar();
                          setActiveLink("crm");
                        }}
                        className={activeLink === "crm" ? "active" : ""}
                      >
                        CRM
                      </Link>
                      <Link
                        to="/pos"
                        onClick={() => {
                          closeNavbar();
                          setActiveLink("pos");
                        }}
                        className={activeLink === "pos" ? "active" : ""}
                      >
                        POS
                      </Link>
                      <Link
                        to="/real-estate"
                        onClick={() => {
                          closeNavbar();
                          setActiveLink("real-estate");
                        }}
                        className={activeLink === "real-estate" ? "active" : ""}
                      >
                        Real Estate
                      </Link>
                      <Link
                        to="/travelagencyandtourbooking"
                        onClick={() => {
                          closeNavbar();
                          setActiveLink("travelagencyandtourbooking");
                        }}
                        className={
                          activeLink === "travelagencyandtourbooking"
                            ? "active"
                            : ""
                        }
                      >
                        Travel Agency & Tour Booking
                      </Link>
                      <Link
                        to="/realestatedirectory"
                        onClick={() => {
                          closeNavbar();
                          setActiveLink("realestatedirectory");
                        }}
                        className={
                          activeLink === "realestatedirectory" ? "active" : ""
                        }
                      >
                        Real Estate Directory
                      </Link>
                      <Link
                        to="/mp-lms"
                        onClick={() => {
                          closeNavbar();
                          setActiveLink("mp-lms");
                        }}
                        className={activeLink === "mp-lms" ? "active" : ""}
                      >
                        MP-LMS
                      </Link>
                      <Link
                        to="/aifsd"
                        onClick={() => {
                          closeNavbar();
                          setActiveLink("aifsd");
                        }}
                        className={activeLink === "aifsd" ? "active" : ""}
                      >
                        AI Full Stack Web Developer
                      </Link>
                    </div>
                    <div className="dropdown-column">
                      <Link
                        to="/rental-booking"
                        onClick={() => {
                          closeNavbar();
                          setActiveLink("rental-booking");
                        }}
                        className={
                          activeLink === "rental-booking" ? "active" : ""
                        }
                      >
                        Rentals Booking
                      </Link>
                      <Link
                        to="/single-vendor"
                        onClick={() => {
                          closeNavbar();
                          setActiveLink("single-vendor");
                        }}
                        className={
                          activeLink === "single-vendor" ? "active" : ""
                        }
                      >
                        Ecommerce-Single Vendor
                      </Link>
                      <Link
                        to="/multi-vendor"
                        onClick={() => {
                          closeNavbar();
                          setActiveLink("multi-vendor");
                        }}
                        className={
                          activeLink === "multi-vendor" ? "active" : ""
                        }
                      >
                        Ecommerce-Multivendor
                      </Link>
                      <Link
                        to="/lms"
                        onClick={() => {
                          closeNavbar();
                          setActiveLink("lms");
                        }}
                        className={activeLink === "lms" ? "active" : ""}
                      >
                        Learning Management System
                      </Link>
                      <Link
                        to="/event-management"
                        onClick={() => {
                          closeNavbar();
                          setActiveLink("event-management");
                        }}
                        className={activeLink === "event-management" ? "active" : ""}
                      >
                        Event Management
                      </Link>

                      <Link
                        to="/mpdemand"
                        onClick={() => {
                          closeNavbar();
                          setActiveLink("mpdemand");
                        }}
                        className={activeLink === "mpdemand" ? "active" : ""}
                      >
                        MPDEMAND
                      </Link>
                      <Link
                        to="/mpfood"
                        onClick={() => {
                          closeNavbar();
                          setActiveLink("mpfood");
                        }}
                        className={activeLink === "mpfood" ? "active" : ""}
                      >
                        MPFood
                      </Link>
                    </div>
                    <div className="dropdown-column">
                      <Link
                        to="/mpproperty"
                        onClick={() => {
                          closeNavbar();
                          setActiveLink("mpproperty");
                        }}
                        className={activeLink === "mpproperty" ? "active" : ""}
                      >
                        MPProperty
                      </Link>
                      <Link
                        to="/mpjobs"
                        onClick={() => {
                          closeNavbar();
                          setActiveLink("mpjobs");
                        }}
                        className={activeLink === "mpjobs" ? "active" : ""}
                      >
                        MPJobs
                      </Link>
                      <Link
                        to="/mpbid"
                        onClick={() => {
                          closeNavbar();
                          setActiveLink("mpbid");
                        }}
                        className={activeLink === "mpbid" ? "active" : ""}
                      >
                        MPBid
                      </Link>
                      <Link
                        to="/mprelax"
                        onClick={() => {
                          closeNavbar();
                          setActiveLink("mprelax");
                        }}
                        className={activeLink === "mprelax" ? "active" : ""}
                      >
                        MPRelax
                      </Link>
                      <Link
                        to="/mpskills"
                        onClick={() => {
                          closeNavbar();
                          setActiveLink("mpskills");
                        }}
                        className={activeLink === "mpskills" ? "active" : ""}
                      >
                        MPSkills
                      </Link>
                      <Link
                        to="/mpdoctor"
                        onClick={() => {
                          closeNavbar();
                          setActiveLink("mpdoctor");
                        }}
                        className={activeLink === "mpdoctor" ? "active" : ""}
                      >
                        MPDoctor
                      </Link>
                      <Link
                        to="/mpmatrimony"
                        onClick={() => {
                          closeNavbar();
                          setActiveLink("mpmatrimony");
                        }}
                        className={activeLink === "mpmatrimony" ? "active" : ""}
                      >
                        MPMatrimony
                      </Link>
                    </div>
                  </div>
                </div> */}
                <Link
                  to="/blogs"
                  onClick={() => {
                    setExpanded(false);
                    setActiveLink("blogs");
                  }}
                  className={activeLink === "blogs" ? "active" : ""}
                >
                  Blogs
                </Link>
                <Nav.Link
                  className="getaquote"
                  style={{
                    backgroundColor: "rgb(14,89,145)",
                    padding: "8px 10px",
                    color: "white",
                    borderRadius: "30px",
                    marginLeft: "10px"
                  }}
                  href="/contact"
                  onClick={() => setExpanded(false)}
                >
                  Get a Quote
                </Nav.Link>
              </Nav>
            </Navbar.Collapse>
          </div>
        </div>
      </Navbar>
    </>
  );
};
export default CustomNavbar;
